// Test IDs used across the landing page
export const LANDING = {
  nav: "site-nav",
  navLogo: "nav-logo",
  navCta: "nav-cta-trial",
  heroSection: "section-hero",
  heroHeadline: "hero-headline",
  heroCta: "hero-cta-trial",
  heroSecondaryCta: "hero-cta-secondary",
  storySection: "section-story",
  gallerySection: "section-gallery",
  instructorsSection: "section-instructors",
  instructorCard: "instructor-card",
  achievementsSection: "section-achievements",
  programsSection: "section-programs",
  programCard: "program-card",
  scheduleSection: "section-schedule",
  scheduleRow: "schedule-row",
  locationSection: "section-location",
  footerSection: "site-footer",
  // Lead form
  trialDialog: "trial-dialog",
  trialForm: "trial-form",
  trialName: "trial-input-name",
  trialPhone: "trial-input-phone",
  trialEmail: "trial-input-email",
  trialProgram: "trial-select-program",
  trialMessage: "trial-input-message",
  trialSubmit: "trial-submit",
  trialClose: "trial-close",
};
